import React from 'react';
import { connectSubpages } from 'app/hocs/subpageManagable';
import { compose } from 'redux';
import { Field } from 'redux-form';
import { Layout, Flex } from 'app/components/base/Layout';
import CompactInput from 'app/components/base/CompactInput';
import TimetableLightbox from 'app/components/search-results/TimetableLightbox';
import builder from '../builder';

import style from './style.css';
import posthog from 'posthog-js';
import moment from 'moment';

// Constants
const icons = {
  clock: { family: 'mozio', name: 'clock', small: false },
  calendar: { family: 'mozio', name: 'calendar', small: false },
};

/**
 * Desktop component for selecting pickup date and time
 * @param {String} type For styling label for different directions
 */
export class DesktopPickupDateTime extends React.Component {
  handleClick = (event) => {
    const { subpages } = this.props;
    const {
      selectedTicket,
      scheduleDepartureTime,
      updateSchedule,
      isReturn,
      trip,
    } = this.props.timeProps;
    // fix to avoid double call of onClick
    event.stopPropagation();

    if (!trip) return;

    subpages.pushPage(TimetableLightbox, {
      trip,
      selectedTicket,
      isReturn,
      onConfirm: ({ departureTicket, updatedTrip }) => {
        const actionParamName = isReturn ? 'returnTicket' : 'departureTicket';
        scheduleDepartureTime({
          [actionParamName]: departureTicket,
          updatedTrip,
          bookTripForm: true,
        });
      },
      onCloseDialog: () => updateSchedule({ trip: null }),
    });
  };

  render() {
    const { fieldName, minDate, notime, ticketValidityMessage, timeProps } =
      this.props;

    return (
      <Layout direction="column" className={style.fields} nowrap>
        <Layout direction="row" align="start center" nowrap>
          <Flex size="50" className={style.input}>
            <Field
              component={CompactInput}
              name={fieldName}
              type="date"
              icon={icons.calendar}
              minDate={minDate}
              onChange={(e) => {
                const initial_value_date = moment(this.props.value).format(
                  'DD/MM/YYYY'
                );
                const end_value_date = moment(e).format('DD/MM/YYYY');
                const diff_value_date =
                  moment(e).diff(moment(this.props.value), 'days') +
                  ' day' +
                  (moment(e).diff(moment(this.props.value), 'days') > 1
                    ? 's'
                    : '');

                const posthogPayload = {
                  initial_value_date,
                  end_value_date,
                  diff_value_date,
                };

                posthog.capture('Date Selected', posthogPayload);
              }}
              rectangled
              notime
            />
          </Flex>
          <Flex size="50">
            {!notime && (
              <Field
                component={CompactInput}
                name={fieldName}
                type="time"
                minDate={minDate}
                icon={icons.clock}
                rectangled
                onClick={this.handleClick}
                onChange={(e) => {
                  const initial_value_time = moment(this.props.value).format(
                    'HH:mm'
                  );
                  const end_value_time = moment(e).format('HH:mm');

                  const diff_value_time =
                    Math.ceil(
                      moment(e).diff(moment(this.props.value), 'minutes') / 60
                    ) +
                    ' hour' +
                    (Math.ceil(
                      moment(e).diff(moment(this.props.value), 'minutes') / 60
                    ) > 1
                      ? 's'
                      : '');

                  const posthogPayload = {
                    initial_value_time,
                    end_value_time,
                    diff_value_time,
                  };

                  posthog.capture('Time Selected', posthogPayload);
                }}
                {...timeProps}
              />
            )}
            {!!ticketValidityMessage && (
              <div className={style.ticketValidity}>
                {ticketValidityMessage}
              </div>
            )}
          </Flex>
        </Layout>
      </Layout>
    );
  }
}

// TODO: move to Flow types
// DesktopPickupDateTime.propTypes = {
//   fieldName: PropTypes.string,
//   minDate: PropTypes.object,
//   notime: PropTypes.bool,
//   subpages: PropTypes.object,
//   ticketValidityMessage: PropTypes.node,
//   timeProps: PropTypes.object
// };

export default compose(builder, connectSubpages())(DesktopPickupDateTime);
